module.exports = __webpack_public_path__ + "media/images/upload-image-8abd1fcc.png";